import {Directive, ViewContainerRef} from '@angular/core';

@Directive({
  selector: '[middleResourceLayout]'
})
export class ResourceMiddleLayoutDirective {

  constructor(public viewContainerRef: ViewContainerRef) {
  }

}
